export default {
  percentage: '#.#',
}
